export const texts = {
  dashboard: {
    de: 'Dashboard',
    en: 'Dashboard'
  },
  positions: {
    de: 'Stellen',
    en: 'Positions'
  },
  positionsImported: {
    de: 'Importiert',
    en: 'Imported'
  },
  positionsAnalysisRequested: {
    de: 'Analyse beantragt',
    en: 'Analysis requested'
  },
  positionsPrepared: {
    de: 'Analysiert',
    en: 'Analyzed'
  },
  positionsLonglists: {
    de: 'Longlists',
    en: 'Longlists'
  },
  positionsOutreach: {
    de: 'In Ansprache',
    en: 'In outreach'
  },
  positionsCompleted: {
    de: 'Beendet',
    en: 'Completed'
  },
  reporting: {
    de: 'Auswertung',
    en: 'Analytics'
  },
  pool: {
    de: 'Talentpool',
    en: 'Talent pool'
  },
  chats: {
    de: 'Chats',
    en: 'Chats'
  },
  notifications: {
    de: 'Benachrichtigungen',
    en: 'Notifications'
  },
  settings: {
    de: 'Einstellungen',
    en: 'Settings'
  },
  logout: {
    de: 'Logout',
    en: 'Logout'
  }
};
